<template>
  <div class="scroll-indicator">
    <span class="scroll-indicator__wr">
      <span class="scroll-indicator__handle" />
    </span>
    <span v-if="label">{{ $t('general.scroll') }}</span>
  </div>
</template>

<script setup>
const props = defineProps({
  label: Boolean
})
</script>

<style lang="scss" scoped>
.scroll-indicator {
  &__wr {
    overflow: hidden;
    display: flex;
    width: 1px;
    height: 40px;
    background-color: var(--color-dark-grey);
  }

  &__handle {
    width: 100%;
    height: 100%;
    background-color: var(--color-white);
    animation: scroll-indicator 3s ease-out infinite;
  }
}

@keyframes scroll-indicator {
  0% {
    transform: translateY(100%);
  }

  60% {
    transform: translateY(0%);
    transform-origin: top;
  }

  80% {
    transform: translateY(0%);
    transform-origin: top;
  }

  100% {
    transform: translateY(100%);
    transform-origin: top;
  }
}
</style>
